
                                module.exports = new Proxy({}, {
                                    get: function() {
                                        const shouldLog = window?.posthog?.config?.debug
                                        if (shouldLog) {
                                            console.warn('[TOOLBAR] Attempted to use denied module:', "scenes/insights/filters/ActionFilter/ActionFilterRow/ActionFilterRow");
                                        }
                                        return function() {
                                            return {}
                                        }
                                    }
                                });
                            